/* sk-pdp-shorts.js — YouTube-Shorts auf Produktseiten (sections/sk-pdp-shorts.liquid), 30.10.2026 Fable-Spec C3/D3.
   Beim Seitenaufruf nur Vorschaubild. Klick → Lightbox (<dialog>, 9:16) mit youtube-nocookie.com, Pfeile/Esc/Backdrop,
   Wechsel zum nächsten Video; Slider-Dots (mobil) und Pfeile (Desktop, nur wenn scrollbar). */
document.addEventListener('error', (e) => {
  const img = e.target;
  if (img instanceof HTMLImageElement && img.classList.contains('sk-shorts__thumb') && img.dataset.fallback && img.src !== img.dataset.fallback) img.src = img.dataset.fallback;
}, true);

let lb = null;
function lightbox() {
  if (lb) return lb;
  lb = document.createElement('dialog');
  lb.className = 'sk-shorts-lb';
  lb.innerHTML = '<button type="button" class="sk-shorts-lb__close" aria-label="Close">×</button><button type="button" class="sk-shorts-lb__nav sk-shorts-lb__nav--prev" aria-label="‹">‹</button><div class="sk-shorts-lb__player"></div><button type="button" class="sk-shorts-lb__nav sk-shorts-lb__nav--next" aria-label="›">›</button>';
  document.body.append(lb);
  const close = () => { lb.querySelector('.sk-shorts-lb__player').innerHTML = ''; if (lb.open) lb.close(); document.documentElement.style.overflow = ''; };
  lb.addEventListener('click', (e) => { if (e.target === lb || e.target.closest('.sk-shorts-lb__close')) close(); });
  lb.addEventListener('close', () => { lb.querySelector('.sk-shorts-lb__player').innerHTML = ''; document.documentElement.style.overflow = ''; });
  lb.querySelector('.sk-shorts-lb__nav--prev').addEventListener('click', () => lb._go(-1));
  lb.querySelector('.sk-shorts-lb__nav--next').addEventListener('click', () => lb._go(1));
  lb.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') lb._go(1); if (e.key === 'ArrowLeft') lb._go(-1); });
  return lb;
}
function play(list, i) {
  const d = lightbox();
  const btn = list[i];
  const id = encodeURIComponent(btn.dataset.skShort);
  const f = document.createElement('iframe');
  f.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1&modestbranding=1`;
  f.title = btn.getAttribute('aria-label') || 'YouTube';
  f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
  f.allowFullscreen = true;
  const p = d.querySelector('.sk-shorts-lb__player');
  p.innerHTML = '';
  p.append(f);
  d.querySelector('.sk-shorts-lb__close').setAttribute('aria-label', document.documentElement.lang === 'de' ? 'Schließen' : 'Close');
  d.querySelector('.sk-shorts-lb__nav--prev').hidden = list.length < 2;
  d.querySelector('.sk-shorts-lb__nav--next').hidden = list.length < 2;
  d._go = (dir) => play(list, (i + dir + list.length) % list.length);
  if (!d.open) { d.showModal(); document.documentElement.style.overflow = 'hidden'; }
  d.querySelector('.sk-shorts-lb__close').focus();
}
document.addEventListener('click', (e) => {
  const btn = e.target instanceof Element ? e.target.closest('[data-sk-short]') : null;
  if (!btn) return;
  e.preventDefault();
  const list = Array.from((btn.closest('.sk-shorts') || document).querySelectorAll('[data-sk-short]'));
  play(list, Math.max(0, list.indexOf(btn)));
});

/* Slider: Dots (aktive Karte) + Pfeile nur bei Überlauf */
function initTrack(root) {
  const track = root.querySelector('[data-sk-shorts-track]');
  if (!track || track.__sk) return;
  track.__sk = 1;
  const items = Array.from(track.children);
  const dots = Array.from(root.querySelectorAll('.sk-shorts__dot'));
  const prev = root.querySelector('[data-sk-shorts-prev]');
  const next = root.querySelector('[data-sk-shorts-next]');
  const step = () => (items[0] ? items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || '0') : track.clientWidth);
  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    if (prev) prev.hidden = max <= 2 || track.scrollLeft <= 2;
    if (next) next.hidden = max <= 2 || track.scrollLeft >= max - 2;
    if (dots.length) {
      const i = Math.round(track.scrollLeft / Math.max(1, step()));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === Math.min(i, dots.length - 1)));
    }
  };
  prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
}
document.querySelectorAll('.sk-shorts').forEach(initTrack);
document.addEventListener('shopify:section:load', () => document.querySelectorAll('.sk-shorts').forEach(initTrack));
